var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Vue from 'vue';
import { createMosaicTransferableFrom } from "../../lib/mosaicUtils";
import { WalletsHelper } from "../../lib/storage";
import { getAccountHttp, getMosaicHttp } from "../../lib/nisUtils";
import { Address, XEM } from "nem-library";
import { getDivided } from "../../lib/numberUtils";
const mosaicDescriptionsDefault = {};
export default Vue.extend({
    data() {
        return {
            balance: 0,
            ownedMosaics: [],
            mosaicDescriptions: Object.assign({}, mosaicDescriptionsDefault)
        };
    },
    methods: {
        fetchBalance(withMosaics = false, onFetched = () => { }, onError = () => { }) {
            return __awaiter(this, void 0, void 0, function* () {
                const activeWallet = yield WalletsHelper.getActive();
                if (activeWallet == null) {
                    return;
                }
                const accountHttp = getAccountHttp();
                const address = new Address(activeWallet.address);
                accountHttp.getMosaicOwnedByAddress(address).subscribe(mosaics => {
                    this.ownedMosaics = [];
                    const mosaicHttp = getMosaicHttp();
                    const mosaicCount = mosaics.length;
                    for (let mosaic of mosaics) {
                        if (mosaic.mosaicId.name === "xem" && mosaic.mosaicId.namespaceId === "nem") {
                            const amount = getDivided(mosaic.quantity, 6).toNumber();
                            this.balance = amount;
                            const xem = new XEM(amount);
                            this.ownedMosaics.push(xem);
                            this.mosaicDescriptions[xem.mosaicId.description()] = '';
                        }
                        else {
                            if (withMosaics) {
                                mosaicHttp.getMosaicDefinition(mosaic.mosaicId).subscribe(mosaicDefinition => {
                                    const mosaicTransferable = createMosaicTransferableFrom(mosaicDefinition, mosaic.quantity);
                                    this.ownedMosaics.push(mosaicTransferable);
                                    this.ownedMosaics = this.ownedMosaics.sort((left, right) => {
                                        return left.mosaicId.description().localeCompare(right.mosaicId.description());
                                    });
                                    this.mosaicDescriptions[mosaicTransferable.mosaicId.description()] = mosaicDefinition.description;
                                    if (this.ownedMosaics.length === mosaicCount) {
                                        onFetched(this.balance, this.ownedMosaics);
                                    }
                                }, error => {
                                    this.balance = 0;
                                    this.ownedMosaics = [];
                                    this.mosaicDescriptions = Object.assign({}, mosaicDescriptionsDefault);
                                    onError(error);
                                });
                            }
                        }
                    }
                    if (!withMosaics || this.ownedMosaics.length === mosaicCount) {
                        onFetched(this.balance, this.ownedMosaics);
                    }
                }, error => {
                    this.balance = 0;
                    this.ownedMosaics = [];
                    onError(error);
                });
            });
        }
    },
});



//////////////////
// WEBPACK FOOTER
// ./src/components/mixins/BalanceModule.ts
// module id = 186
// module chunks = 1